
























import CustomerContactCard from "@/components/partner/CustomerContactCard.vue";
import UserAdministrationDetailPermissionsAddDialog from "@/components/partner/UserAdministrationDetailPermissionsAddDialog.vue";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { AuthRolesEnum } from "@/store/enum/authRolesEnum";
import { UserAdministrationModule } from "@/store/modules/admin-user.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "../utility/Card.vue";

@Component({
  components: {
    CustomerContactCard,
    UserAdministrationDetailPermissionsAddDialog,
    Card
  }
})
export default class UserAdministrationDetailRoles extends DarkModeHighlightMixin {
  @Prop({ default: true })
  disabled = true;

  editRoles: AuthRolesEnum[] = [];
  authRoles = Object.keys(AuthRolesEnum).map(k => AuthRolesEnum[k as any]);

  loading = false;

  get isLoading() {
    return this.loading;
  }

  get roles() {
    return UserAdministrationModule.selectedUser.roles;
  }

  edit() {
    this.disabled = false;
    this.editRoles = [];
    this.editRoles.push(...UserAdministrationModule.selectedUser.roles);
  }

  close() {
    this.editRoles = [];
    this.disabled = true;
  }

  async save() {
    this.loading = true;
    UserAdministrationModule.selectedUser.roles = [];
    const updatedUser = await UserAdministrationModule.updateSelectedUserRoles({
      id: UserAdministrationModule.selectedUser._id,
      role: this.editRoles
    });

    if (!updatedUser) {
      Vue.$toast.error("Rollen konnten nicht geändert werden.");
      this.loading = false;
    } else {
      Vue.$toast.success("Rollen erfolgreich geändert.");
      this.loading = false;
    }
    this.close();
  }
}
